import { useState } from "react";

function LuxuryImage({
  src,
  alt,
  className = "",
  skeletonClass = ""
}) {

  const [loaded, setLoaded] =
    useState(false);

  return (

    <div className="relative overflow-hidden">

      {/* SKELETON */}

      {!loaded && (

        <div
          className={`
            absolute inset-0
            animate-pulse
            bg-stone-200
            ${skeletonClass}
          `}
        />

      )}

      {/* IMAGE */}

      <img
        src={src}
        alt={alt}
        loading="lazy"
        onLoad={() => setLoaded(true)}
        className={`
          transition duration-700 ease-out
          ${loaded ? "opacity-100 scale-100" : "opacity-0 scale-105"}
          ${className}
        `}
      />

    </div>

  );

}

export default LuxuryImage;